import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

// Styles
import { Button, CircularProgress, Grid, Modal, Typography } from '@mui/material';
import { X } from 'phosphor-react';

// Apis
import { getRelatory } from 'js/library/utils/API/getRelatory';
import { sendCommunicationMessage } from 'js/library/utils/API/sendCommunicationMessage';

const buttonCloseStyle = {
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  minWidth: 'auto',
  padding: '0.5rem',
  borderRadius: '50%',
  color: '#000',
};

const containerStyle = {
  padding: '2rem',
  backgroundColor: 'white',
  borderRadius: '8px',
  maxWidth: {
    xs: '90%', // Mobile
    md: '45%', // Desktop
  },
  width: '100%',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

export const ModalBudgetSummary = ({
  budgetResume,
  open,
  close,
  reload,
  subsequentApproval,
  userPoints,
}) => {
  const [loading, setLoading] = useState(false);
  const [loadingRelatory, setLoadingRelatory] = useState(true);
  const [finalRelatory, setFinalRelatory] = useState({});

  const { resumeQuote, communicationMessageId, isRelatory, isFinalRelatory } = budgetResume || {};
  const { channel, totalUsers, totalCost } = resumeQuote || {};

  useEffect(() => {
    isFinalRelatory &&
      getRelatory(communicationMessageId)
        .then((relatory) => setFinalRelatory(relatory))
        .catch((error) => toast.error(error))
        .finally(() => setLoadingRelatory(false));
  }, [communicationMessageId]);

  const approveQuote = async () => {
    try {
      setLoading(true);
      const approvalSuccess = await sendCommunicationMessage(communicationMessageId);
      toast.success(approvalSuccess);
      subsequentApproval ? reload((prev) => !prev) : window.history.back();
      close();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const closeAndBack = () => {
    !subsequentApproval && window.history.back();
    close();
  };

  const selectTitle = () => {
    if (isRelatory) return 'Relatório de orçamento';
    if (isFinalRelatory) return 'Relatório de envio';
    return 'Aprovação de orçamento';
  };

  if (!open) return null;

  return (
    <Modal open={open} onClose={closeAndBack}>
      <Grid container sx={containerStyle}>
        <Button onClick={closeAndBack} sx={buttonCloseStyle}>
          <X size={25} />
        </Button>

        <Grid item md={12} xs={12}>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            {selectTitle()}
          </Typography>
        </Grid>

        <Grid item md={12} xs={12}>
          <Typography variant="h6">
            {isFinalRelatory ? (
              loadingRelatory ? (
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
                  <CircularProgress size={40} thickness={6} />
                </div>
              ) : (
                <ul style={{ listStyleType: 'none', margin: '1rem 0' }}>
                  <li>Total de pessoas selecionadas: {finalRelatory?.qtyParticipants || 0}</li>
                  <li>Mensagens não entregues: {finalRelatory?.qtyErrorsUsers || 0}</li>
                  <li>Mensagens entregues com sucesso: {finalRelatory?.qtySendedUsers || 0}</li>
                </ul>
              )
            ) : (
              <ul style={{ listStyleType: 'none', margin: '1rem 0' }}>
                <li style={{ margin: '1.2rem 0' }}>Canal selecionado: {channel || '_'}</li>

                <li>Total de pessoas selecionadas: {totalUsers || 0}</li>
                <li>
                  Valor unitário: {totalUsers ? totalCost / totalUsers : 0}{' '}
                  {totalUsers && totalCost / totalUsers === 1 ? 'ponto' : 'pontos'}
                </li>
                <li style={{ marginBottom: '1.2rem' }}>
                  Valor total: {totalCost || 0} {totalCost === 1 ? 'ponto' : 'pontos'}
                </li>

                <li style={{ fontWeight: 700 }}>Seus pontos: {userPoints || 0}</li>
                <li style={{ fontWeight: 700 }}>
                  Seus pontos após a operação: {userPoints - totalCost}
                </li>
              </ul>
            )}
          </Typography>
        </Grid>

        {isFinalRelatory && !loadingRelatory && (
          <Grid item md={12} xs={12} sx={{ marginTop: '2rem' }}>
            <a
              href={finalRelatory?.relatoryFilePath}
              download
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <Button variant="contained">Baixar relatório completo</Button>
            </a>
          </Grid>
        )}

        {!isRelatory && !isFinalRelatory && (
          <Grid
            item
            md={12}
            xs={12}
            sx={{ display: 'flex', justifyContent: 'center', marginTop: '2rem', gap: 2 }}
          >
            <Button
              disabled={loading}
              onClick={approveQuote}
              variant="contained"
              sx={{ minWidth: '14rem' }}
            >
              {loading ? (
                <CircularProgress size={23} thickness={6} sx={{ color: '#fff' }} />
              ) : (
                'Aprovar e enviar mensagem'
              )}
            </Button>
            <Button onClick={closeAndBack} variant="outlined">
              Aprovar mais tarde
            </Button>
          </Grid>
        )}
      </Grid>
    </Modal>
  );
};
